import ErrorCode from "@/constants/ErrorCode";
export const statusCourier = status => {
    switch ( String(status) ) {
        case 'BOOKING':
            return { status: `รอขนส่งเข้ารับ` , color: `status-parcel-info`}
        case 'SHIPPING':
            return { status: `กำลังนำส่ง` , color: `status-parcel-warning`} 
        case 'RETURN':
            return { status: `พัสดุถูกตีกลับ` , color: `status-parcel-danger`} 
        case 'COMPLETE':
            return { status: `นำส่งสำเร็จ` , color: `status-parcel-success`} 
        case 'CANCEL_FAIL':
            return { status: `ยกเลิกไม่สำเร็จ` , color: `status-parcel-danger`}
        case 'CANCEL':
            return { status: `ยกเลิกสำเร็จแล้ว` , color: `status-parcel-success`} 
        case 'PENDING_CANCEL':
            return { status: `รอดำเนินการยกเลิก` , color: `status-parcel-warning`} 
        case 'PENDING_TRANSFER':
            return { status: `รอดำเนินการโอนเงิน` , color: `status-parcel-warning`}
        case 'TRANSFERRED':
            return { status: `โอนเงินสำเร็จแล้ว` , color: `status-parcel-success`}
        case 'CANCEL_TRANSFER':
            return { status: `โอนเงินไม่สำเร็จ` , color: `status-parcel-danger`}
        default:
            return { status: `รอเข้าระบบ` , color: `status-parcel-info`}
    }
};

export const getTooltip = (item, courierCodeKey = 'courier_code') => {
    if (item.status == 'CANCEL') {
        return item.remark_cancel
    } else if (item.status == 'INVALID') {
        let errorMessage = 'เกิดข้อผิดพลาด ไม่สามารถสร้างรายการไปยังขนส่งได้' 
        if (ErrorCode[item[courierCodeKey]] && ErrorCode[item[courierCodeKey]][item.sp_error_msg]) {
            errorMessage = ErrorCode[item[courierCodeKey]][item.sp_error_msg];
        } else if (item.sp_error_msg){
            errorMessage = item.sp_error_msg
        }
        return errorMessage
    } else {
        return ''
    }
}

export const statusInfo = (item, customField = {
        status: 'status', 
        courier_code: 'courier_code'
    }) => {
    let info = {}
    let statusKey = 'status'
    let courierCodeKey = 'courier_code'
    console.log('customField', customField)
    if (customField.status) {
        statusKey = customField.status
    }
    if (customField.courier_code) {
        courierCodeKey = customField.courier_code
    }
    switch ( String(item[statusKey]) ) {
        case 'BOOKING':
            return { status: `รอขนส่งเข้ารับ` , color: `status-parcel-info`}
        case 'SHIPPING':
            return { status: `กำลังนำส่ง` , color: `status-parcel-warning`} 
        case 'RETURN':
            return { status: `พัสดุถูกตีกลับ` , color: `status-parcel-danger`} 
        case 'COMPLETE':
            info = { 
                status: `นำส่งสำเร็จ` , 
                color: `status-parcel-success`,
            }
            return info
        case 'INVALID': 
            info = { 
                status: `เกิดข้อผิดพลาด` , 
                color: `status-parcel-danger`,
            } 
            info.tooltip = getTooltip(item, courierCodeKey)
            console.log('info', info)
            return info
        case 'CANCEL_FAIL':
            return { status: `ยกเลิกไม่สำเร็จ` , color: `status-parcel-danger`}
        case 'CANCEL':
            info = { 
                status: `ยกเลิกสำเร็จแล้ว` , 
                color: `status-parcel-success`, 
            } 
            info.tooltip = getTooltip(item, courierCodeKey)
            return info
        case 'PENDING_CANCEL':
            return { status: `รอดำเนินการยกเลิก` , color: `status-parcel-warning`} 
        case 'PENDING_TRANSFER':
            return { status: `รอดำเนินการโอนเงิน` , color: `status-parcel-warning`}
        case 'TRANSFERRED':
            return { status: `โอนเงินสำเร็จแล้ว` , color: `status-parcel-success`}
        case 'CANCEL_TRANSFER':
            return { status: `โอนเงินไม่สำเร็จ` , color: `status-parcel-danger`}
        default:
            return { status: `รอเข้าระบบ` , color: `status-parcel-info`}
    }
};